const changeUserPasswordToast = (state = null, action) => {
  if (action.type === "SET_CHANGE_USER_PASSWORD_TOAST") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "SET_CHANGE_USER_PASSWORD_TOAST": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default changeUserPasswordToast;
